import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-69faa370"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "standard"
};
const _hoisted_2 = {
  class: "td"
};
const _hoisted_3 = {
  class: "product"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "asin-sku"
};
const _hoisted_8 = {
  class: "standard"
};
const _hoisted_9 = {
  class: "sub-cells"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_16 = {
  class: "title",
  style: {
    "background-color": "#F2FFFD"
  }
};
const _hoisted_17 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_18 = {
  class: "standard",
  style: {
    "background-color": "#F5F7FA"
  }
};
const _hoisted_19 = {
  class: "title",
  style: {
    "background-color": "#F5F7FA"
  }
};
const _hoisted_20 = {
  key: 1,
  style: {
    "text-align": "end",
    "font-size": "14px"
  }
};
const _hoisted_21 = {
  class: "standard"
};
const _hoisted_22 = {
  class: "sub-cells"
};
const _hoisted_23 = {
  class: "title"
};
const _hoisted_24 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_29 = {
  class: "title",
  style: {
    "background-color": "#F5FBFF"
  }
};
const _hoisted_30 = {
  key: 1,
  style: {
    "text-align": "end"
  }
};
const _hoisted_31 = {
  class: "standard"
};
const _hoisted_32 = {
  class: "td center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_switch = _resolveComponent("app-switch");
  return _openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(['app-row', {
      selected: $props.selected
    }]),
    onClick: _cache[54] || (_cache[54] = (...args) => $options.onSelect && $options.onSelect(...args))
  }, [_createElementVNode("td", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.item.main_image_link,
    alt: ""
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($props.item.product_name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($props.item.asin) + " - " + _toDisplayString($props.item.sku), 1)])])])]), _createElementVNode("td", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-product-length-cm`]
    }]),
    onClick: _cache[5] || (_cache[5] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-product-length-cm`)),
    style: {
      "background-color": "#F8FFFE"
    }
  }, [_createElementVNode("div", _hoisted_10, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-product-length-cm` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-product-length-cm`,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-length-cm`] = $event),
    onInput: _cache[1] || (_cache[1] = $event => $options.onUpdateLengthItem($event, 'product_package_length_cm')),
    class: "title unit-color",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%",
      "background-color": "#F8FFFE"
    },
    onBlur: _cache[2] || (_cache[2] = $event => $options.onUpdate('product_package_length_cm')),
    onKeyup: _cache[3] || (_cache[3] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-product-height-cm`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-length-cm`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($options.lengthValue($props.item.product_package_length_cm)), 1))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-product-height-cm`]
    }]),
    onClick: _cache[11] || (_cache[11] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-product-height-cm`)),
    style: {
      "background-color": "#F8FFFE"
    }
  }, [_createElementVNode("div", _hoisted_12, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-product-height-cm` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-product-height-cm`,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-height-cm`] = $event),
    onInput: _cache[7] || (_cache[7] = $event => $options.onUpdateLengthItem($event, 'product_package_height_cm')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%",
      "background-color": "#F8FFFE"
    },
    onBlur: _cache[8] || (_cache[8] = $event => $options.onUpdate('product_package_height_cm')),
    onKeyup: _cache[9] || (_cache[9] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-product-width-cm`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-height-cm`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($options.lengthValue($props.item.product_package_height_cm)), 1))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-product-width-cm`]
    }]),
    onClick: _cache[17] || (_cache[17] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-product-width-cm`)),
    style: {
      "background-color": "#F8FFFE"
    }
  }, [_createElementVNode("div", _hoisted_14, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-product-width-cm` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-product-width-cm`,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-width-cm`] = $event),
    onInput: _cache[13] || (_cache[13] = $event => $options.onUpdateLengthItem($event, 'product_package_width_cm')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%",
      "background-color": "#F8FFFE"
    },
    onBlur: _cache[14] || (_cache[14] = $event => $options.onUpdate('product_package_width_cm')),
    onKeyup: _cache[15] || (_cache[15] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-product-weight-kg`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-width-cm`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($options.lengthValue($props.item.product_package_width_cm)), 1))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-product-weight-kg`]
    }]),
    style: {
      "background-color": "#F2FFFD"
    },
    onClick: _cache[23] || (_cache[23] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-product-weight-kg`))
  }, [_createElementVNode("div", _hoisted_16, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-product-weight-kg` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-product-weight-kg`,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-weight-kg`] = $event),
    onInput: _cache[19] || (_cache[19] = $event => $options.onUpdateLengthItem($event, 'product_package_weight_kg')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%",
      "background-color": "#F2FFFD"
    },
    onBlur: _cache[20] || (_cache[20] = $event => $options.onUpdate('product_package_weight_kg')),
    onKeyup: _cache[21] || (_cache[21] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-units-per-box`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-product-weight-kg`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($options.weightValue($props.item.product_package_weight_kg)), 1))])], 2)])]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell-unit", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-units-per-box`]
    }]),
    onClick: _cache[28] || (_cache[28] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-units-per-box`))
  }, [_createElementVNode("div", _hoisted_19, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-units-per-box` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-units-per-box`,
    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $props.item.units_per_box = $event),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%",
      "background-color": "#F5F7FA"
    },
    onBlur: _cache[25] || (_cache[25] = $event => $options.onUpdate('units_per_box')),
    onKeyup: _cache[26] || (_cache[26] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-box-length-cm`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*",
    onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $props.item.units_per_box]]) : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($props.item.units_per_box), 1))])], 2)]), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-box-length-cm`]
    }]),
    onClick: _cache[34] || (_cache[34] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-box-length-cm`))
  }, [_createElementVNode("div", _hoisted_23, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-box-length-cm` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-box-length-cm`,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-length-cm`] = $event),
    onInput: _cache[30] || (_cache[30] = $event => $options.onUpdateLengthItem($event, 'box_length_cm')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%"
    },
    onBlur: _cache[31] || (_cache[31] = $event => $options.onUpdate('box_length_cm')),
    onKeyup: _cache[32] || (_cache[32] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-box-height-cm`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-length-cm`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($options.lengthValue($props.item.box_length_cm)), 1))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-box-height-cm`]
    }]),
    onClick: _cache[40] || (_cache[40] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-box-height-cm`))
  }, [_createElementVNode("div", _hoisted_25, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-box-height-cm` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-box-height-cm`,
    "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-height-cm`] = $event),
    onInput: _cache[36] || (_cache[36] = $event => $options.onUpdateLengthItem($event, 'box_height_cm')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%"
    },
    onBlur: _cache[37] || (_cache[37] = $event => $options.onUpdate('box_height_cm')),
    onKeyup: _cache[38] || (_cache[38] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-box-width-cm`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[39] || (_cache[39] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-height-cm`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($options.lengthValue($props.item.box_height_cm)), 1))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-box-width-cm`]
    }]),
    onClick: _cache[46] || (_cache[46] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-box-width-cm`))
  }, [_createElementVNode("div", _hoisted_27, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-box-width-cm` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-box-width-cm`,
    "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-width-cm`] = $event),
    onInput: _cache[42] || (_cache[42] = $event => $options.onUpdateLengthItem($event, 'box_width_cm')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%"
    },
    onBlur: _cache[43] || (_cache[43] = $event => $options.onUpdate('box_width_cm')),
    onKeyup: _cache[44] || (_cache[44] = _withKeys($event => $options.focusNextCell(`${$props.item.asin}-${$props.item.sku}-box-weight-kg`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[45] || (_cache[45] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-width-cm`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString($options.lengthValue($props.item.box_width_cm)), 1))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["sub-cell", {
      selected: $data.selectedCells[`${$props.item.asin}-${$props.item.sku}-box-weight-kg`]
    }]),
    style: {
      "background-color": "#F5FBFF"
    },
    onClick: _cache[52] || (_cache[52] = $event => $options.focusInput(`${$props.item.asin}-${$props.item.sku}-box-weight-kg`))
  }, [_createElementVNode("div", _hoisted_29, [$data.isInputActive === `${$props.item.asin}-${$props.item.sku}-box-weight-kg` ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    type: "number",
    ref: `${$props.item.asin}-${$props.item.sku}-box-weight-kg`,
    "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-weight-kg`] = $event),
    onInput: _cache[48] || (_cache[48] = $event => $options.onUpdateLengthItem($event, 'box_weight_kg')),
    class: "title",
    style: {
      "text-align": "end",
      "border": "none",
      "outline": "none",
      "width": "100%",
      "height": "100%"
    },
    onBlur: _cache[49] || (_cache[49] = $event => $options.onUpdate('box_weight_kg')),
    onKeyup: _cache[50] || (_cache[50] = _withKeys($event => $options.onBlur(`${$props.item.asin}-${$props.item.sku}-box-weight-kg`), ["enter"])),
    inputmode: "numeric",
    pattern: "[0-9]*\\.?[0-9]*",
    onClick: _cache[51] || (_cache[51] = _withModifiers(() => {}, ["stop"]))
  }, null, 544)), [[_vModelText, $data.convertedInputValues[`${$props.item.asin}-${$props.item.sku}-box-weight-kg`]]]) : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString($options.weightValue($props.item.box_weight_kg)), 1))])], 2)])]), _createElementVNode("td", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_app_switch, {
    modelValue: $props.item.expiration_date_required,
    "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => $props.item.expiration_date_required = $event),
    onChange: $options.onExpirationDateRequired
  }, null, 8, ["modelValue", "onChange"])])])], 2);
}